
export const articleReceived = articles => ({
    type: 'ARTICLES_RECEIVED',
    payload: articles
});
